import React, { Component } from 'react'
import { Layout, Form, Input, Button, message, Select, DatePicker, InputNumber, Spin } from 'antd'
import { graphql } from 'react-apollo'
import { inject, observer } from 'mobx-react'
import Loading from '~/components/Loading/index'
import couponCodeTypeQuery from '~/graphql/queries/couponCodeType.gql'
import updateCouponCodeTypeMutation from '~/graphql/mutations/updateCouponCodeType.gql'
import createCouponCodeTypeMutation from '~/graphql/mutations/createCouponCodeType.gql'
import eventsQuery from '~/graphql/queries/eventPagination.gql'
import eventQuery from '~/graphql/queries/event.gql'
import { Link } from 'react-router-dom'
import EventSider from '~/components/Events/Event/Sider'
import _get from 'lodash/get'
import _flatMap from 'lodash/flatMap'
import moment from 'moment-timezone'
import DeleteConfirmModal from './DeleteConfirmModal'
import { withTranslation } from 'react-i18next'
import config from '~/config'
import _debounce from 'lodash/debounce';

const FormItem = Form.Item
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 8 }
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 12 }
  }
}
const toDateTimeFormat = 'YYYY-MM-DDTHH:mm:ss.SSSSZ'
const { RangePicker } = DatePicker
const toPercentage = (value) => {
  return value ? (value * 100).toFixed(2) : 0
}
const dateFormat = 'DD/MM/YYYY HH:mm:ss'

@inject('router')
@observer
@Form.create()
@graphql(couponCodeTypeQuery, {
  options: (props) => ({
    variables: {
      _id: props.match.params.couponCodeTypeId,
      eventId: props.match.params.eventId
    }
  }),
  props: ({ data: { loading, couponCodeType } }) => ({
    couponCodeTypeLoading: loading,
    couponCodeType: couponCodeType
  }),
  fetchPolicy: 'network-only'
})
@graphql(eventQuery, {
  options: (props) => ({
    variables: {
      _id: props.match.params.eventId
    }
  }),
  props: (ep) => ({
    eventLoading: ep.data.loading,
    event: ep.data.event,
    ep
  }),
  fetchPolicy: 'network-only'
})
@graphql(createCouponCodeTypeMutation, { name: 'createCouponCodeTypeMutation' })
@graphql(updateCouponCodeTypeMutation, { name: 'updateCouponCodeTypeMutation' })
@graphql(eventsQuery, {
  props: ({ data }) => ({
    eventsLoading: data.loading,
    eventsError: data.error,
    events: data.SearchEventPagination,
    fetchMore: data.refetch
  }),
  options: {
    variables: {
      search: '',
      page: 1
    },
    fetchPolicy: 'network-only'
  }
})
class Edit extends Component {
  state = {
    loading: false,
    eventIds: [],
    events: [],
    fetching: false,
    groupColorMap: {},
  }

  handleSubmit = (e) => {
    const { couponCodeType, event } = this.props
    e.preventDefault()
    this.setState({ loading: true })
    this.props.form.validateFields((err, value) => {
      const validityPeriod = _get(value, 'validityPeriod')
      if (err) {
        this.setState({ loading: false })
        return
      }
      if (_get(value, 'discountType') === 'percentage') {
        value.discount = value.discount / 100
      }
      const record = {
        // _id: this.props.couponCodeType._id,
        ...value,
        masterType: 'RegistrationType',
        accessOverride: true,
        ...(validityPeriod && {
          validityPeriod: {
            start: moment(validityPeriod[0]._d).format(toDateTimeFormat),
            end: moment(validityPeriod[1]._d).format(toDateTimeFormat)
          }
        })
      }
      // console.log('record', record)
      if (couponCodeType) {
        this.props.updateCouponCodeTypeMutation({
          variables: {
            record: {
              _id: this.props.couponCodeType._id,
              ...record,
            }
          }
        }).then((response) => {
          message.success(`save successfully`)
        }).catch((e) => {
          message.error(`${e}`)
        }).finally(() => {
          this.setState({ loading: false })
        })
      } else {
        this.props.createCouponCodeTypeMutation({
          variables: {
            record: {
              ...record,
              eventId: event._id
            }
          }
        }).then((response) => {
          const couponCodeTypeId = _get(response, 'data.createCouponCodeType.record._id')
          message.success(`create successfully`)
          if (couponCodeTypeId) {
            this.props.history.push(`/fetchPage?link=/events/${event._id}/coupon-code-types/${couponCodeTypeId}/edit`)
          }
        }).catch((e) => {
          message.error(`${e}`)
        })
      }
    })
  }

  render() {
    const { couponCodeType, event, couponCodeTypeLoading, eventLoading, ep, history, t, eventsLoading } = this.props
    console.log('couponCodeType', couponCodeType)
    if (couponCodeTypeLoading) return <Loading />
    if (eventLoading) return <Loading />
    // console.log(couponCodeType)
    const { getFieldDecorator, getFieldValue, setFieldsValue } = this.props.form
    const couponCodeTypeId = _get(this.props, 'match.params.couponCodeTypeId')
    console.log('event', event, ep.data, _get(ep, 'data.error.message'), this.props)
    if (_get(ep, 'data.error.networkError.type') === 'WriteError') {
      window.location.reload()
      return <Loading />
    }

    let events
    if (!this.props.eventsloading && this.props.events) {
      events = this.props.events.items
      // onRowClick = (record) => document.location.href = `/events/${record._id}`
    }
    // console.log({events: this.state.events, couponCodeType})
    const eventId = _get(event, '_id')
    const eventName = _get(event, 'name.th', '') || _get(event, 'name.th', '')
    const allregistrationTypes = _get(couponCodeType, 'registrationType', [])
    const registrationTypesAll = _get(event, 'registrationTypes', [])
    const registrationTypes = registrationTypesAll.concat(allregistrationTypes)

    // console.log({ticketTypesTypes})
    const masterIds = _get(couponCodeType, 'masterIds')

    const mergedTickets = _flatMap(allregistrationTypes, "ticketTypes");
    const ticketTypesTypes = _get(event, 'ticketTypes').concat(mergedTickets)
    // console.log({registrationTypes})

    // console.log({allregistrationTypes})
    const ticketTypeIds = _get(couponCodeType, 'ticketTypeIds')
    const discountTypes = [{ name: `${t('coupon.fixed')}`, value: 'flat' }, { name: '%', value: 'percentage' }]
    const validityPeriod = [
      moment.utc(_get(couponCodeType, 'validityPeriod.start')),
      moment.utc(_get(couponCodeType, 'validityPeriod.end'))
    ]
    const name = {
      en: _get(couponCodeType, 'name.en', ''),
      th: _get(couponCodeType, 'name.th', ''),
      ms: _get(couponCodeType, 'name.ms', ''),
    }
    const nameEnDecorator = getFieldDecorator('name.en', {
      rules: [{ required: true, message: `${t('coupon.messageEN')}` }],
      initialValue: name.en
    })
    const nameThDecorator = getFieldDecorator(`name.${config.default_locale}`, {
      rules: [{ required: true, message: `${t('coupon.message')} ${config.default_locale} name` }],
      initialValue: _get(couponCodeType, `name.${config.default_locale}`)
    })
    const masterIdsDecorator = getFieldDecorator('masterIds', {
      initialValue: masterIds,
      rules: [{ required: true, message: 'Please input master' }]
    })
    const ticketTypeIdsDecorator = getFieldDecorator('ticketTypeIds', {
      initialValue: ticketTypeIds
      // rules: [{ required: true, message: 'Please input ticketType' }]
    })
    const validityPeriodDecorator = getFieldDecorator('validityPeriod', {
      initialValue: validityPeriod,
      rules: [{ required: true, message: 'Please input Validity Period' }]
    })

    let discount = _get(couponCodeType, 'discount')
    let discountType = getFieldValue('discountType') || _get(couponCodeType, 'discountType')
    if (!discountType) discountType = discountTypes[0].value
    if (discountType === 'percentage') {
      discount = toPercentage(discount)
    }

    const initEventIds = _get(couponCodeType, 'eventIds')

    const onSearch = async (e) => {
      console.log(e, 'eeee');
      this.setState({ fetching: true })
      console.log('A')
      await this.props.fetchMore({
        search: e,
        page: this.state.page
      })
      console.log('B')
      this.setState({ events: this.props.events.items, fetching: false })
      console.log('B=C')
    };

    const getRandomColor = (value, index) => {
      const colors = ['red', 'blue', 'green', 'orange', 'purple', 'cyan', 'magenta'];
      return colors[index];
    };

    const initialValues = getFieldValue('eventIds') || []
    const newColorMap = {};
    initialValues.forEach((value, index) => {
      if (!newColorMap[value]) {
        newColorMap[value] = getRandomColor(value, index);
      }
    });

    return <Layout>
      <EventSider />
      <div className="editContent code-box">
        <Form onSubmit={this.handleSubmit}>
          <FormItem
            wrapperCol={{ xs: { span: 24 }, sm: { span: 18, offset: 6 } }}
          >
            <div className="modDeleteButton">
              <DeleteConfirmModal loading={this.props.loading} t={this.props.t}
                couponCodeTypeId={couponCodeTypeId} history={this.props.history}
                name={name.th || name.en} />
            </div>
            <h2 className="title">
              {couponCodeType ? t('coupon.editCoupon') : t('coupon.edit.newCoupon')}
            </h2>
          </FormItem>
          {couponCodeType && <FormItem
            label="ID"
            {...formItemLayout}
          >
            {couponCodeTypeId}
          </FormItem>}
          <FormItem
            label={`${t('coupon.edit.eventId')}`}
            {...formItemLayout}
          >
            {eventId}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.eventName')}`}
            {...formItemLayout}
          >
            {eventName}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.name')} [EN]`}
            {...formItemLayout}
          >
            {nameEnDecorator(
              <Input />
            )}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.name')} [${config.default_locale.toUpperCase()}]`}
            {...formItemLayout}
          >
            {nameThDecorator(
              <Input />
            )}
          </FormItem>
          <FormItem
            label='eventids'
            {...formItemLayout}
          >
            {getFieldDecorator('eventIds', {
              initialValue: initEventIds,
              // rules: [{ required: true, message: `${t('coupon.edit.message')}` }]
            })(
              <Select
                mode="multiple"
                showSearch
                notFoundContent={eventsLoading ? <Spin size="small" /> : null}
                filterOption={false}
                onSearch={_debounce(onSearch, 800)}
              >
                {events?.map(d => (
                  <Option key={d._id}><span style={{ color: newColorMap[d._id] }}>{d.name.th}</span></Option>
                ))}
              </Select>
            )}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.registrationType')}`}
            {...formItemLayout}
          >
            {registrationTypes && masterIdsDecorator(
              <Select mode="multiple" showSearch>
                {registrationTypes.map(registrationType =>
                  <Select.Option key={registrationType._id} value={registrationType._id}>
                    <span style={{ color: newColorMap[registrationType.eventId] }}>{_get(registrationType, 'name.th') || _get(registrationType, 'name.en')}</span>
                  </Select.Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.ticketType')}`}
            {...formItemLayout}
          >
            {ticketTypesTypes && ticketTypeIdsDecorator(
              <Select mode="multiple" showSearch>
                {ticketTypesTypes.map(ticketTypesType =>
                  <Select.Option key={ticketTypesType._id} value={ticketTypesType._id}>
                    <span style={{ color: newColorMap[ticketTypesType.eventId] }}>{_get(ticketTypesType, 'name.th') || _get(ticketTypesType, 'name.en')}</span>
                  </Select.Option>
                )}
              </Select>
            )}
          </FormItem>
          <FormItem label="Activity Type" {...formItemLayout}>
            {getFieldDecorator('activityType', {
              initialValue: _get(couponCodeType, 'activityType', 'all'),
            })(
              <Select>
                <Select.Option key="running" value="running">Running</Select.Option>
                <Select.Option key="swimming" value="swimming">Swimming</Select.Option>
                <Select.Option key="triathlon" value="triathlon">Triathlon</Select.Option>
                <Select.Option key="all" value="all">All</Select.Option>
              </Select>
            )}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.date')}`}
            {...formItemLayout}
          >
            {validityPeriodDecorator(
              <RangePicker showTime format={dateFormat} />
            )}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.discountType')}`}
            {...formItemLayout}
          >
            {getFieldDecorator(`discountType`, {
              initialValue: discountType
            })(<Select
              // mode="multiple"
              size='default'
              style={{ width: '100%' }}
            >
              {discountTypes.map(c =>
                <Select.Option key={c.value} value={c.value}>
                  {c.name}
                </Select.Option>
              )}
            </Select>)}
          </FormItem>
          <FormItem
            label={`${t('coupon.edit.discount')}`}
            {...formItemLayout}
          >
            {getFieldDecorator('discount', {
              initialValue: discount,
              rules: [{ required: true, message: `${t('coupon.edit.message')}` }]
            })(
              <InputNumber min={0} max={getFieldValue(`discountType`) === 'percentage' ? 100 : 1000000} />
            )}
          </FormItem>
          <FormItem
            label="copies"
            {...formItemLayout}
          >
            {getFieldDecorator('copies', {
              initialValue: _get(couponCodeType, 'copies', 1),
              rules: [{ required: true, message: `${t('coupon.edit.message')}` }]
            })(
              <InputNumber min={0} />
            )}
          </FormItem>
          <FormItem
            wrapperCol={{ xs: { span: 24 }, sm: { span: 16, offset: 8 } }}
          >
            <Button type="primary" htmlType="submit" loading={this.state.loading}>{`${t('coupon.edit.save')}`}</Button>
            <Link to={`/events/${eventId}/coupon-code-types/list`} style={{ marginLeft: '10px' }}>
              <Button loading={this.state.loading}>{`${t('coupon.edit.cancel')}`}</Button>
            </Link>
          </FormItem>
        </Form>
      </div>
    </Layout>
  }
}

export default withTranslation()(Edit)
